/* ---------- Audience presets (shared by Tech-Invite + Broadcast modals) ----------
 * One-click shortcuts that flip the audience-toggle Set to a sensible combo.
 * Keeps the most common workflows to a single click without removing the
 * granular per-cohort toggles below.
 */
export const AUDIENCE_PRESETS = [
  { key: "pipeline",     label: "Stufe-2-Pipeline", cohorts: ["leads", "customers", "contacts"],
    hint: "Leads + Kunden + Kontakte" },
  { key: "full_crm",     label: "Komplettes CRM",   cohorts: ["leads", "customers", "contacts", "partners"],
    hint: "+ Partner" },
  { key: "webinar_loop", label: "Webinar-Wiederkehrer", cohorts: ["past_attendees", "past_registrants"],
    hint: "Teilnehmer + Registranten" },
  { key: "everyone",     label: "Alle",             cohorts: ["leads", "customers", "contacts", "partners", "past_attendees", "past_registrants"],
    hint: "Maximaler Reach" },
];

export default function AudiencePresets({ onApply, activeSet, accent = "purple" }) {
  // Highlight a preset as "selected" only when the current audience Set
  // matches its cohorts exactly — so admins see at a glance whether they
  // ended up on a known preset or built a custom selection.
  const matches = (cohorts) => {
    if (cohorts.length !== activeSet.size) return false;
    return cohorts.every((c) => activeSet.has(c));
  };
  const ring = accent === "sky" ? "ring-sky-200 border-sky-500 bg-sky-50" : "ring-purple-200 border-purple-500 bg-purple-50";
  return (
    <div className="flex flex-wrap gap-1.5 mb-2.5">
      {AUDIENCE_PRESETS.map((p) => {
        const active = matches(p.cohorts);
        return (
          <button
            key={p.key}
            type="button"
            data-testid={`audience-preset-${p.key}`}
            onClick={() => onApply(p.cohorts)}
            title={p.hint}
            className={`text-[11px] font-semibold px-3 py-1.5 rounded-full border transition-all ${
              active ? `${ring} ring-2` : "border-slate-200 bg-white text-slate-700 hover:border-slate-400"
            }`}
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
}
